import script from "./MotorError.vue?vue&type=script&setup=true&lang=ts"
export * from "./MotorError.vue?vue&type=script&setup=true&lang=ts"

import "./MotorError.vue?vue&type=style&index=0&id=63f1e753&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63f1e753"]])

export default __exports__